import Insight from "../insightClass";
import React from "react";
import { insight109Media } from "../../../assets/assetReference";
import { ContactSubscribe } from "../../../components/Contact/Contact";
export const insight109 = new Insight(
  "27 April 2026",
  {
    pageTitle: "Global Offshore Wind Weekly",
    metaDescription: "WeBridge Insights, Global Offshore Wind Weekly",
    keyWords:
      "European Offshore Wind Market development, Global Offshore Wind Weekly",
  },
  {
    src: insight109Media[0],
    alt: "offshore wind farm",
  },
  "Global Offshore Wind Weekly (2026-04-27)",
  "",
  `The first turbine has been installed at the 1.4GW East Anglia Three offshore wind farm, located 69km off Suffolk. The project will use 95 Siemens Gamesa 14+MW turbines and is expected to power the equivalent of 1.3 million British homes once operational. Its 115-metre blades are the first of this size to be deployed on a UK offshore wind project, with all 285 blades being manufactured in Hull.`,
  <div>
    <strong>WeBridge Insights</strong>
    <h1>Global Offshore Wind Weekly (2026-04-27)</h1>
    <h2></h2>
    <p className="article-date">27 April 2026</p>
    <br />
    <p>
      Welcome to this week's <i>WeBridge Insights</i>, where we provide you with
      the latest updates and key developments from the global offshore wind
      market.
    </p>
    <br />
    <br />
    <br />
    <p>
      At <b>WeBridge</b>, we deliver forward-thinking analysis and expert
      commentary to keep you informed in this fast-evolving industry. Here's our
      roundup of the top stories this week, complete with professional insights
      to help you stay ahead:
    </p>

    <h3>1. UK: First turbine installed at East Anglia Three</h3>
    <p>
      The first turbine has been installed at the 1.4GW East Anglia Three
      offshore wind farm, located 69km off Suffolk. The project will use 95
      Siemens Gamesa 14+MW turbines and is expected to power the equivalent of
      1.3 million British homes once operational. Its 115-metre blades are the
      first of this size to be deployed on a UK offshore wind project, with all
      285 blades being manufactured in Hull.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      East Anglia Three is important because it moves beyond planning and
      financing into visible execution. For the UK, this is not just another
      project milestone. It demonstrates that large-scale offshore wind can
      still progress despite pressure on costs, ports, vessels and supply
      chains. The use of UK-made blades also matters politically and
      industrially, as the UK continues to link offshore wind deployment with
      domestic manufacturing and regional jobs.
    </p>
    <h3>
      2. Scotland: Nadara submits consent applications for 1.8GW Bellrock
      floating wind project
    </h3>
    <p>
      Nadara has submitted Section 36 consent and Marine Licence applications
      for the 1.8GW Bellrock floating offshore wind project in Scottish waters.
      The project is located around 120km east of Stonehaven and could include
      up to 132 floating turbines, floating substructures, mooring systems,
      inter-array cables and subsea cable hubs. Subject to approval,
      construction is expected to begin in 2031.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      Bellrock is a significant signal for Scotland’s floating wind ambitions.
      The project is large enough to test whether floating wind can move from
      demonstration scale into commercial-scale infrastructure. The key
      challenge will not only be consent, but also port readiness, grid
      connection, floating foundation manufacturing capacity and long-term
      offtake economics. Scotland has strong seabed resources, but the next
      phase will be defined by delivery capability.
    </p>
    <h3>
      3. Scotland: Fred. Olsen Seawind to take full ownership of Muir Mhòr
    </h3>
    <p>
      Fred. Olsen Seawind has agreed to acquire Vattenfall’s 50% stake in the
      1GW Muir Mhòr floating offshore wind project, subject to regulatory
      approvals. The project, located around 63km off Peterhead, secured seabed
      rights through ScotWind and is targeting generation in the early 2030s.
      Vattenfall said the move reflects its wider portfolio priorities.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      This is a portfolio discipline story as much as a project story.
      Developers are increasingly concentrating capital on projects where they
      see clearer routes to consent, grid, auctions and returns. For floating
      wind, ownership simplification can be positive if it improves
      decision-making speed. But it also shows that early-stage floating
      projects remain capital-intensive and strategically selective.
    </p>
    <h3>
      4. Ireland: GE Vernova and Energia investigate blade failure at Drumlins
      wind farm
    </h3>
    <p>
      GE Vernova and Energia are investigating a blade failure at the 48MW
      Drumlins wind farm in County Monaghan, Ireland. The incident occurred on
      22 April 2026 and involved turbine 8 within the eight-turbine array. The
      project is equipped with GE Vernova 6.1-158 machines, and no injuries were
      reported.
    </p>
    <p>
      Both companies are now conducting a joint investigation, likely involving
      detailed inspection of the blade structure, operational data and
      environmental conditions at the time of the incident.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      Blade incidents are not uncommon in the wind industry, but their
      significance is increasing as turbine sizes continue to grow. Larger
      blades are subject to higher mechanical loads and more complex material
      stresses, making reliability a critical focus area even for established
      turbine platforms.
    </p>
    <p>
      More broadly, the event reflects a wider industry trend: as turbine
      ratings increase, tolerance for failure decreases. Ensuring consistent
      quality across design, manufacturing, transport and installation is
      becoming increasingly important. Reliability and lifecycle performance are
      now central to both project economics and supply chain competitiveness.
    </p>
    <h3>
      5. Europe: Offshore wind repowering and North Sea grid cooperation rise up
      the agenda
    </h3>
    <p>
      European policy attention has shifted towards repowering existing offshore
      wind assets and improving cross-border cable infrastructure. Offshore wind
      repowering has been identified as part of a broader energy-security
      strategy, while five transmission system operators from Belgium, Denmark,
      Germany and the Netherlands have launched a joint initiative on North Sea
      offshore cable infrastructure.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      Europe’s offshore wind challenge is no longer only about winning seabed
      and building turbines. It is about system design. Repowering can unlock
      more output from existing sites, while coordinated transmission can reduce
      duplication, cost and grid bottlenecks. The North Sea is moving from a
      collection of national offshore wind zones towards a shared energy system.
    </p>
    <h3>6. France: EolMed floating wind pilot begins grid testing</h3>
    <p>
      The 30MW EolMed floating offshore wind pilot has begun a critical testing
      phase off Port-La Nouvelle and Gruissan. The project uses three Vestas
      V164-10.0MW turbines installed on BW Ideol floating foundations in around
      60 metres of water. The start of testing marks progress towards full
      commissioning and first renewable power exports to the grid.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      France’s floating wind pilots are strategically important because they
      provide operating data for future commercial tenders. Floating wind
      remains expensive, but pilot projects help validate foundations, mooring
      systems, dynamic cables, installation methods and O&M models. For
      Mediterranean markets with deeper waters, these pilots are essential
      stepping stones.
    </p>
    <h3>
      7. United States: Engie explores refunds for US offshore wind leases
    </h3>
    <p>
      Engie is in discussions with the US administration over possible refunds
      for offshore wind project leases. The company has paused three US offshore
      wind projects and recorded impairments linked to its Ocean Winds joint
      venture. The move follows wider uncertainty in the US offshore wind
      market, where policy direction has become a major investment risk.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      The US is becoming a case study in how political risk can override
      technical and commercial fundamentals. Offshore wind projects depend on
      long-term policy stability, permitting confidence and supply-chain
      commitments. When these conditions weaken, capital moves elsewhere. For
      European developers, the US is no longer simply a high-growth market; it
      is a market requiring careful political-risk pricing.
    </p>

    <br />
    <br />
    <br />
    <p>
      As the global offshore wind sector continues to advance, innovation,
      investments, and supportive policies are driving transformative growth. At{" "}
      <i>
        <b>WeBridge</b>
      </i>
      , we provide the expertise and insights our partners need to confidently
      navigate this evolving landscape.
    </p>
    <h3 style={{ marginTop: "200px" }}>Subscribe</h3>
    <ContactSubscribe />
  </div>,
);
